import addItem from '../../../../../actions/shop/menu/addItem';
import { toastr } from 'react-redux-toastr';

async function submit(values, dispatch, props) {
  let modifiers = JSON.stringify(values.modifiers);
  let tax = values.tax;
  let weight = null;
  const originalWeight = values.originalWeight;
  const weightUnit = values.weightUnit;

  if (originalWeight != null) {
    const numericWeight = parseFloat(originalWeight);
    if (!isNaN(numericWeight)) {
      // Conversion factors to grams (only kg, g, mg, l, ml)
      const conversionFactors = {
        'g': 1,
        'kg': 1000,
        'mg': 0.001,
        'l': 1000,
        'ml': 1
      };

      const unit = weightUnit ? weightUnit.toLowerCase() : 'g';
      const conversionFactor = conversionFactors[unit] || 1;
      weight = numericWeight * conversionFactor;
    }
  }

  if (!values.tax || (values.tax && values.tax.toString().trim() === '')) tax = null;

  // Set default image based on delivery type
  const profile = props?.profile;
  if (!values.image || values.image === 'default.jpg') {
    if (profile && profile.deliveryType === 3) {
      values.image = 'groceryDefault.jpg';
    } else {
      values.image = 'default.jpg';
    }
  }

  let variables = Object.assign({}, values, {
    modifiers,
    tax,
    weight,
    originalWeight,
    weightUnit,
    discountType: values.discountType,
    discountValue: values.discountValue,
    isStockEnabled: values.isStockEnabled === true || values.isStockEnabled === 'true',
    stock: values.isStockEnabled === true || values.isStockEnabled === 'true' ? (values.stock !== undefined && values.stock !== null && values.stock !== '' ? parseInt(values.stock, 10) : 0) : null,
    sku: values.sku || null,
    upc: values.upc || null,
  });

  if (!values.image) toastr.error('Error!', 'Please upload the image for item');
  else await dispatch(addItem(variables));
}

export default submit;
